import { Button } from "@kanda-libs/ks-design-library";
import type { FunctionComponent } from "react";

export interface ListFilterButtonProps {
  id: string;
  active?: boolean;
  label: string;
  activeLabel: string;
  onClick: () => void;
}

const ListFilterButton: FunctionComponent<ListFilterButtonProps> = function ({
  id,
  active = false,
  label,
  activeLabel,
  onClick,
}) {
  return (
    <Button.Text
      left
      id={id}
      variant={active ? "gradient" : "solid"}
      icon={active ? "check" : ""}
      label={active ? activeLabel : label}
      onClick={onClick}
    />
  );
};

export default ListFilterButton;
